"use client"

import { ReplyAll } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ReplyAllIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ReplyAllIcon = component(Icon)({ as: ReplyAll })
